import { Console } from 'console';
import { ThunkPropsInterface } from '../../helpers/store-helper';
import { AuthenticationService, UserService } from '../../services';
import { metadataActions } from './metadata-actions';

export const metadataThunks = {
  login: async (
    { dispatch, actionSuccess, actionError }: ThunkPropsInterface,
    email: string,
    password: string,
    successCallback?: Function,
    errorCallback?: Function
  ) => {
    const data = await AuthenticationService.login(email, password);

    if (data) {
      dispatch(actionSuccess(data));
      dispatch(metadataActions.getLoggedInUserData);
      successCallback?.();
    } else {
      dispatch(actionError());
      errorCallback?.();
    }
  },

  logout: async ({ dispatch, actionSuccess, actionError }: ThunkPropsInterface, successCallback?: Function) => {
    try {
      const isSuccess = AuthenticationService.logout();

      if (isSuccess) {
        dispatch(actionSuccess({ isLogged: false, teamId: null }));
        successCallback?.();
      } else {
        dispatch(actionError());
      }
    } catch (error) {
      dispatch(actionError());
    }
  },

  getLoggedInUserData: async ({ dispatch, actionSuccess, actionError }: ThunkPropsInterface, callback?: Function) => {
    try {
     
      const isLogged = AuthenticationService.isLogged();
      const loggedInTeamId = AuthenticationService.getLoggedInTeamId();

      if (!isLogged) {
        dispatch(actionSuccess({}));
        callback?.();
        return;
      }

      if (!loggedInTeamId) {
        dispatch(actionError());
        callback?.();
        return;
      }

      // const response = await UserService.getUser(loggedInUserId);
      // const user = response.data?.user_profiles?.[0];

      // if (!response.isSuccess || !user) {
      //   dispatch(actionError());
      //   callback?.();
      //   return;
      // }

      dispatch(actionSuccess({ isLogged: true, teamId: loggedInTeamId }));
      callback?.();
    } catch (error) {
      dispatch(actionError());
    }
  },
};
